import { Box, Text } from '@opendoor/bricks-next';

type OfferRangeElementProps = {
  props: {
    min: number;
    max: number;
  };
};

const formatNumber = (num: number | undefined) => {
  if (num === undefined) {
    return '';
  }
  const dollars = num / 100;
  if (dollars > 1000000) {
    //show up to 2 decimals when displaying millions
    return `${Math.round(dollars / 10000) / 100}M`;
  }
  if (dollars > 1000) {
    return `${Math.round(dollars / 1000)}K`;
  }
  return dollars;
};

const OfferRangeElement: React.FC<OfferRangeElementProps> = ({ props }) => {
  const { min, max } = props;
  return (
    <Box gap="$10x" $smallerThanMD={{ gap: '$8x' }}>
      <Text tag="h1" typography="$subheaderSmall" $smallerThanMD={{ fontSize: '$subheaderXsmall' }}>
        Estimated home value
      </Text>
      <Text tag="h2" typography="$headerLarge" $smallerThanLG={{ typography: '$headerMedium' }}>
        ${formatNumber(min)} - ${formatNumber(max)}
      </Text>
    </Box>
  );
};

export default OfferRangeElement;
